import { Controller } from "@hotwired/stimulus"

export default class InputmaskController extends Controller {
    connect() {
        let textformat = ($(this.element).attr('data-textformat'))
        $(this.element).mask( textformat, {clearIfNotMatch: true} )
    }
}
